import Vue from 'vue'
import Vuex from 'vuex'
import mutations from './mutations'
import actions from './actions'

Vue.use(Vuex)

const store = new Vuex.Store({
  state: {
    user: {},
    userIsLogged: false,
    dashboardType: '',
    // transaction: {
    //   amount: '102.50',
    //   currency: '€'
    // },
    // donation: 3.85,
    currentName: 'Login',
    namesHistory: ['Login'],
    selectedCause: 0,
    payments: {}
  },
  mutations,
  actions
})

export default store



// WEBPACK FOOTER //
// ./src/store/index.js